import { PropType } from 'vue'
import './Notifications.scss'
import NotificationTopic from './NotificationTopic'
import Vue from 'vue'
import { FORNECEDORES } from '@/constants/Fornecedores'
import { Notification } from './Notification'
import { VBtn, VDivider } from 'vuetify/lib'
import { PROPOSTA_SITUACOES, PROPOSTA_STATUS } from '@/types'
import { StringHelper } from '@/utils/StringHelper'

export interface INotificationBaseProps {
	topic: 'Proposta'
	category: 'Status' | 'Observacao'
}

export interface INotificationsResponse {
	notifications: INotificationItem[]
	proposalId: number
	lastNotification: string
	unread: number
}

export interface INotificationItem {
	id: string
	topic: 'Status' | 'Observacao'
	category: 'Proposta' | 'PreAnalise'
	userId: number
	createdAt: string
	readAt: null | string
	proposalId: number
	proposalStatus: PROPOSTA_STATUS
	proposalSituation: PROPOSTA_SITUACOES
	referenceId: string
	metadata: string
	clientName: string
	clientDocument: string
	bankId: FORNECEDORES
}

export const NotificationItemBase = Vue.component('NotificationItemBase', {
	name: 'NotificationItemBase',

	props: {
		notificationGroup: { type: Object as PropType<INotificationsResponse>, required: true },
		isVisible: { type: Boolean, required: true, default: false }
	},

	data: () => ({
		expanded: false
	}),

	methods: {
		toggleNotifications() {
			this.expanded = !this.expanded
		},

		closeNotification() {
			this.expanded = false
		}
	},

	computed: {
		lastNotification(): INotificationItem {
			let index = 0
			return this.notificationGroup.notifications[index]
		},

		hasOneNotification(): boolean {
			return this.notificationGroup.notifications.length === 1
		},

		filteredNotifications(): INotificationItem[] {
			return this.notificationGroup.notifications.filter((notification) => notification.id != this.lastNotification.id)
		}
	},

	watch: {
		isVisible: {
			handler(val) {
				if (!val) {
					this.closeNotification()
				}
			}
		}
	},

	render() {
		return (
			<div class="notification-content">
				<div class="px-4 py-3">
					<NotificationTopic notification={this.lastNotification} />

					<Notification notification={this.lastNotification} />

					{this.expanded && !this.hasOneNotification && (
						<div class={['notifications-group', !this.hasOneNotification ? 'notification-is-multiple' : '']}>
							{!this.hasOneNotification && this.filteredNotifications.map((notification) => <Notification notification={notification} />)}
						</div>
					)}

					{!this.hasOneNotification && (
						<VBtn class="mt-2" small text onClick={() => this.toggleNotifications()}>
							{this.expanded ? (
								'Mostrar menos'
							) : (
								<span>
									+ {this.filteredNotifications.length} {StringHelper.pluralizeWord('atualização', this.filteredNotifications.length)}
								</span>
							)}
						</VBtn>
					)}
				</div>
				<VDivider />
			</div>
		)
	}
})
